/*
*
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties
* and other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the applicable
* third party licensors or the open source community as the case may be and nothing here transfers the rights to the third party
* and open source components, except as expressly permitted. Any unauthorized reproduction, storage, transmission in any
* form or by any means (including without limitation to electronic, mechanical, printing, photocopying, recording or
* otherwise), or any distribution of this Program, or any portion of it, may result in severe civil and criminal penalties, and will be
* prosecuted to the maximum extent possible under the law.
*
*/

import { NgModule } from '@angular/core';
import { DataTableComponent } from './components/data-table/data-table.component';
import { MdDataTableComponent } from './components/md-data-table/md-data-table.component';
import { TableHeaderComponent } from './components/table-header/table-header.component';
import { TableSearchComponent } from './components/table-search/table-search.component';
import { TableFilterComponent } from './components/table-filter/table-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import {} from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatRadioModule } from '@angular/material/radio';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';

import { HttpClientModule } from '@angular/common/http';
import { ExpansionPanelComponent } from './components/expansion-panel/expansion-panel.component';

import { CarouselComponent, CarouselItemElement } from './components/carousel/carousel.component';
import { CarouselItemDirective } from './components/carousel/carousel-item.directive';
import { OutsideClickDirective } from './directives/outside-click.directive';
import { MultiSelectDropdownFixDirective } from './directives/multiselect-dropdown-fix.directive';
import { MasterDataService } from './services/master-data.service';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MdContentService } from './services/mdcontent.service';
import { EntityAttributesComponent } from './components/entity-attributes/entity-attributes.component';
import { CommonService } from './services/common.service';
import {
  EntityAttributeTestComponent
} from './components/entity-attribute-components/entity-attribute-test/entity-attribute-test.component';
import { BaNotificationComponent } from './components/ba-notification/ba-notification.component';
import { BaNotificationService } from './services/ba-notification.service';

import { TypewriterComponent } from './components/typewriter/typewriter.component';
import { BaseChartDirective } from 'ng2-charts';
import { TranslateModule } from '@ngx-translate/core';
//import { NvD3Module } from 'ng2-nvd3';
//import 'd3';
//import 'nvd3';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { DynamicFormRowComponent } from './components/dynamic-form/dynamic-form-row/dynamic-form-row.component';
import { DynamicFormControlService } from './services/dynamic-form-control.service';
import { DynamicFormFieldComponent } from './components/dynamic-form/dynamic-form-field/dynamic-form-field.component';
import { TemplateOneComponent } from './components/dynamic-component/template-one/template-one.component';
import {
  DynamicComponentLoaderComponent
} from './components/dynamic-component/dynamic-component-loader/dynamic-component-loader.component';
import { TemplateTwoComponent } from './components/dynamic-component/template-two/template-two.component';
import {
  DynamicComponentViewerComponent
} from './components/dynamic-component/dynamic-component-viewer/dynamic-component-viewer.component';
import { AppNotificationComponent } from './components/app-notification/app-notification.component';
import {
  AppNotificationEventButtonComponent
} from './components/app-notification/app-notification-button-event/app-notification-event-button.component';
import {
  AppNotificationEventPreferencesComponent
} from './components/app-notification/app-notification-event-preferences/app-notification-event-preferences.component';
import { ComponentDialogComponent } from './components/dynamic-component/component-dialog/component-dialog.component';
import { TemplateThreeComponent } from './components/dynamic-component/template-three/template-three.component';
import { TemplateFourComponent } from './components/dynamic-component/template-four/template-four.component';
import { DynamicWrapperComponent } from './components/dynamic-component/dynamic-wrapper/dynamic-wrapper.component';
import { TemplateTwoV1Component } from './components/dynamic-component/template-two-v1/template-two-v1.component';
import { SimpleDialogComponent } from './components/simple-dialog/simple-dialog.component';
import { TemplateFiveComponent } from './components/dynamic-component/template-five/template-five.component';
import { TemplateSixComponent } from './components/dynamic-component/template-six/template-six.component';
import { AuthorizeDirective } from './directives/authorize.directive';
import { AuthDirective } from './directives/auth.directive';
import { FloatingLabelDirective } from './directives/floating-label.directive';
import { FilterToggleDirective, FilterActionDirective } from './directives/filter-actions.directive';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { CommonModule, DatePipe } from '@angular/common';
//import { DragScrollModule } from 'ngx-drag-scroll';
@NgModule({
    imports: [
        CommonModule,
        MatCheckboxModule,
        MatInputModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatSliderModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatPaginatorModule,
        MatTabsModule,
        MatSortModule,
        MatMenuModule,
        MatFormFieldModule,
        MatGridListModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatCardModule,
        MatAutocompleteModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatDialogModule,
        //NvD3Module,
        BaseChartDirective,
        MultiSelectDropdownFixDirective
        //TranslateModule,
        //DragScrollModule,
    ],
    declarations: [
        DataTableComponent,
        MdDataTableComponent,
        TableHeaderComponent,
        TableSearchComponent,
        TableFilterComponent,
        ExpansionPanelComponent,
        CarouselComponent,
        CarouselItemDirective,
        CarouselItemElement,
        OutsideClickDirective,
        EntityAttributesComponent,
        ConfirmDialogComponent,
        EntityAttributeTestComponent,
        TypewriterComponent,
        DynamicFormComponent,
        DynamicFormRowComponent,
        DynamicFormFieldComponent,
        BaNotificationComponent,
        DynamicComponentLoaderComponent,
        DynamicComponentViewerComponent,
        TemplateOneComponent,
        TemplateTwoComponent,
        TemplateThreeComponent,
        TemplateFourComponent,
        TemplateTwoV1Component,
        AppNotificationComponent,
        AppNotificationEventButtonComponent,
        AppNotificationEventPreferencesComponent,
        ComponentDialogComponent,
        DynamicWrapperComponent,
        SimpleDialogComponent,
        TemplateFiveComponent,
        TemplateSixComponent,
        AuthorizeDirective,
        AuthDirective,
        FloatingLabelDirective,
        FilterToggleDirective,
        FilterActionDirective,
        ErrorPageComponent
    ],
    providers: [
        DatePipe,
        MasterDataService,
        MdContentService,
        CommonService,
        DynamicFormControlService,
        BaNotificationService
    ],
    exports: [
        CommonModule,
        MatCheckboxModule,
        MatInputModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatSliderModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatPaginatorModule,
        MatTabsModule,
        MatSortModule,
        MatMenuModule,
        MatFormFieldModule,
        MatGridListModule,
        MatCardModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        RouterModule,
        MatExpansionModule,
        MatChipsModule,
        MatRadioModule,
        MatNativeDateModule,
        MatDatepickerModule,
        MatDividerModule,
        MatSnackBarModule,
        MatAutocompleteModule,
        MatStepperModule,
        MatDialogModule,
        DataTableComponent,
        MdDataTableComponent,
        TableHeaderComponent,
        TableSearchComponent,
        TableFilterComponent,
        ExpansionPanelComponent,
        CarouselComponent,
        CarouselItemDirective,
        CarouselItemElement,
        OutsideClickDirective,
        FloatingLabelDirective,
        FilterToggleDirective,
        FilterActionDirective,
        ConfirmDialogComponent,
        EntityAttributesComponent,
        TypewriterComponent,
  BaseChartDirective,
  TranslateModule,
        DynamicFormComponent,
        //DragScrollModule,
        BaNotificationComponent,
        DynamicComponentLoaderComponent,
        DynamicComponentViewerComponent,
        AppNotificationComponent,
        AppNotificationEventButtonComponent,
        AppNotificationEventPreferencesComponent,
        SimpleDialogComponent,
        AuthorizeDirective,
        AuthDirective,
        ErrorPageComponent,
        MultiSelectDropdownFixDirective
    ]
})
export class SharedModule { }


